(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('filebrowser', {
      restrict: 'E',
      bindings: {
        filemode: '@',
        clientid: '<?',
        clientmode: '@?'
      },
      template: `
        <h3  ng-show="vm.files.length === 0">
            <span ng-show="vm.filemode === 'scan'">Dokumente zuordnen</span>
            <span ng-show="vm.filemode === 'signoff'">Dokumente vidieren</span>
        </h3>
        <div class="alert alert-info" ng-show="vm.files.length === 0">

            <h4><i class="fa fa-info-circle"></i> Es sind derzeit keine Dokumente zu bearbeiten.</h4>
        </div>
        <div ng-show="vm.files.length > 0">
          <h3>
            <div class="pull-left">
  
              <span class="btn btn-primary" ng-click="vm.firstFile()" uib-tooltip="Erste Datei"><i class="fa fa-step-backward"></i></span>
              <span class="btn btn-primary" ng-click="vm.previousFile()" uib-tooltip="Vorherige Datei"><i class="fa fa-arrow-left"></i></span>
                          <span ng-show="vm.filemode === 'scan'">Dokumente zuordnen: </span>
              <span ng-show="vm.filemode === 'signoff'">Dokumente vidieren: </span>
              Datei {{vm.selectedfile}} von {{vm.files.length}}
            </div>
            <div class="pull-right">
              <span class="btn btn-primary" ng-click="vm.nextFile()" uib-tooltip="Nächste Datei"><i class="fa fa-arrow-right"></i></span>
              <span class="btn btn-primary" ng-click="vm.lastFile()" uib-tooltip="Letzte Datei"><i class="fa fa-step-forward"></i></span>
            </div>
          </h3>
          <div class="clearfix"></div>
          <scansorter file="vm.files[vm.selectedfileindex]" 
                      parentsave="vm.childsave(file, finish)" 
                      clientmode="vm.clientmode"
                      filemode="{{vm.filemode}}" 
                      ng-show="vm.filemode === 'scan' || vm.filemode === 'signoff' "></scansorter>
          </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$window',
        function ($log, File, Rlog, vertxEventBusService, $window) {
          let vm = this;
          vm.childsave = childsave;
          vm.firstFile = firstFile;
          vm.lastFile = lastFile;
          vm.nextFile = nextFile;
          vm.previousFile = previousFile;

          vm.$onInit = function () {
            $log.debug('filebrowser run getFiles $onInit');
            getFiles();
          };

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue)) {
                vm.clientid = changes.clientid.currentValue;
                $log.debug('filebrowser run getFiles $onChange');
                getFiles();
              }
            }
          };

          function getFiles() {
            $log.debug('Filebrowser Get files called');
            if (angular.isDefined(vm.filemode)) {
              let modeerror = false;
              let query = {};
              switch (vm.filemode) {
                case 'scan':
                  query = {active: true, scanstatus: 'captured'};
                  break;
                case 'signoff':
                  query = {active: true, scanstatus: 'assigned'};
                  break;
                case 'findings':
                  query = {active: true, findingsstatus: 'captured'};
                  break;
                case 'findingsignoff':
                  query = {active: true, findingsstatus: 'assigned'};
                  break;
                default:
                  modeerror = true;
              }

              if (angular.isDefined(vm.clientid)) {
                if (vm.clientmode === 'patient') {
                  query.patientid = vm.clientid;
                } else {
                  query.clientid = vm.clientid;
                }
              }

              if (!modeerror) {
                File.$search(query).$then(function (files) {
                  $log.debug('filebrowser Loaded files mode: ', vm.filemode,  files);
                  vm.files = files;
                  vm.selectedfile = 1;
                  vm.selectedfileindex = 0;
                }, function (err) {
                  $log.error('filebrowser file loading error', err);
                  Rlog.error('dms.scan', 'filebrowser', 'file loading error', {});
                  vm.files = [];
                });
              } else {
                vm.files = [];
              }
            }
          }

          function firstFile() {
            vm.selectedfile = 1;
            vm.selectedfileindex = 0;
          }

          function lastFile() {
            vm.selectedfile = vm.files.length;
            vm.selectedfileindex = vm.files.length - 1;
          }

          function nextFile() {
            if (vm.selectedfile < vm.files.length) {
              vm.selectedfile++;
              vm.selectedfileindex++;
            }
          }

          function previousFile() {
            if (vm.selectedfile > 0) {
              vm.selectedfile--;
              vm.selectedfileindex--;
            }
          }

          function childsave(file, finish) {
            $log.debug('childsave called: ', file, finish);

            if (file.$hasPendingActions()) {
              $log.debug('filebrowser File had pending actions, cancelling now.');
              file.$cancel();
            }
            file.$save().$then(function () {
              $log.debug('file saved successfully');
              vm.saved = true;
              if (finish) {
                vertxEventBusService.publish('scanfile.update', {origin: 'filebrowser'}, {timeout: 3000})
                  .then(function (reply) {
                    $log.debug('A eb reply received: ', reply);
                  })
                  .catch(function () {
                    $log.warn('No eb reply message within 3 seconds');
                  });
              }
            }, function (err) {
              vm.saved = false;
              $log.error('saving of file failed: ', err);
              Rlog.error('vcdms.vcscan', 'filebrowser', 'Saving of file failed: ', {fileid: file._id});
            });
          }


          // listen for scan files updates
          vertxEventBusService.on('scanfile.update', function (message) {
            $log.debug('filebrowser eb scanfile.update, refresh files: ', message);
            vm.files.$refresh();
          });


          // listen for files updates
          vertxEventBusService.on('files.update', function (message) {
            $log.debug('filebrowser eb files.update: ', message);
            let fileid = message.split(':')[0];
            let tabid = message.split(':')[1];
            if (tabid !== $window.sessionStorage.getItem('sprtabid')) {
              // refresh file selectively if present in vm.files;
              // TODO: is this really necessary? Should not PDF viewer refresh his own files?
              vm.files.find(function (file) {
                $log.debug('filebrowser eb scanfile.update, refresh files becase update file is in list: ', message);
                if (file._id === fileid) {
                  return file;
                }
              }).$refresh();
            }

          });

        }] // controller
    }); // component

// klammerfriedhof
}());